import { NgModule } from '@angular/core';
import { CSVBoxButtonComponent } from './csvbox-button.component';



@NgModule({
  declarations: [
    CSVBoxButtonComponent
  ],
  imports: [
  ],
  exports: [
    CSVBoxButtonComponent
  ]
})
export class CSVBoxAngularModule { }
